(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2425],{

/***/ 85254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reward-center",
      function () {
        return __webpack_require__(75287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var _app_containers_reward_center__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52389);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55784);




const RewardCenterPage = (param)=>{
    let {} = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_containers_reward_center__WEBPACK_IMPORTED_MODULE_1__/* .RewardCenterContainer */ .l, {})
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .withTranslation */ .Zh)("common")(RewardCenterPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(85254); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);